import axios from "../index"

// 接口基础路径
const rootApi = '/api_v2/production/workOrder'

/** 生产工单列表 */
export const productionOrderPage = (params) => {
  return axios.post(`${rootApi}/productionOrderPage`, params, {dataType: 'json'})
}
/** 老化工单未完成列表 */
export const waitOrderPage = (params) => {
  return axios.post(`${rootApi}/waitOrderPage`, params, {dataType: 'json'})
}
/** 老化工单生产中列表 */
export const inproductionOrderPage = (params) => {
  return axios.post(`${rootApi}/inProductionOrderPage`, params, {dataType: 'json'})
}
/** 根据批次号获取工单 */
export const getByBatchCode = (params) => {
  return axios.get(`${rootApi}/${params}/getVoByCode`)
}
/** 完工工单列表 */
export const completeOrderPage = (params) => {
  return axios.post(`${rootApi}/completeOrderPage`, params, {dataType: 'json'})
}

/** 班组工单列表 */
export const workGroupOrderPage = (params) => {
  return axios.post(`${rootApi}/workGroupOrderPage`, params, {dataType: 'json'})
}

/** 班组完成工单列表 */
export const completeWorkGroupOrderPag = (params) => {
  return axios.post(`${rootApi}/completeWorkGroupOrderPage`, params, {dataType: 'json'})
}

/** 获取工单详情接口 */
export const orderDetail = (workOrderId) => {
  return axios.get(`${rootApi}/${workOrderId}`)
}

/** 获取工单详情列表接口 */
export const getDetailAttrList = (workOrderId) => {
  return axios.get(`${rootApi}/detailAttrList/${workOrderId}`)
}

/** 根据编码获取vo */
export const getWorkOrderVoByCode = (workOrderCode) => {
  return axios.get(`${rootApi}/${workOrderCode}/getVoByCode`)
}

/** 开工 */
export const workOrderStart = (workOrderId) => {
  return axios.put(`${rootApi}/start/${workOrderId}`)
}

/** 暂停 */
export const workOrderPause = (workOrderId) => {
  return axios.put(`${rootApi}/pause/${workOrderId}`)
}
/** ppi暂停 */
export const workOrderPauseppi = (workOrderId) => {
  return axios.put(`/api_v2/production/mergeWorkOrder/pause/${workOrderId}`)
}
/** 领取工单 */
export const workOrderRreceive = (workOrderId, params) => {
  return axios.post(`${rootApi}/receive/${workOrderId}`, params)
}

/** 获取工单批次列表 */
export const batchList = (workOrderId) => {
  return axios.get(`${rootApi}/batchList/${workOrderId}`)
}

/** 验证工单的参数记录是否允许报工 */
export const paramRecordValid = (workOrderId) => {
  return axios.get(`${rootApi}/paramRecordValid/${workOrderId}`)
}

/** 直接报工 */
export const directlyReport = (params) => {
  return axios.post(`${rootApi}/directlyReport`, params)
}
/** 累计报工 */
export const addReport = (params) => {
  return axios.post(`${rootApi}/addReport`, params)
}

/** 拆批报工数据 */
export const splitConfirmData = (params) => {
  return axios.post(`${rootApi}/splitConfirmData`, params)
}

/** 拆批报工 */
export const splitReport = (params) => {
  return axios.post(`${rootApi}/splitReport`, params)
}

/** 上料校验 */
export const loadMaterielValid = (params) => {
  return axios.get(`/api_v2/production/auxiliaryMateriel/loadMaterielValid`, {params})
}
/** 签卡 */
export const signatureFlowOrder = (params) => {
  return axios.get(`/api_v2/production/workOrder/signatureFlowOrder`, {params})
}
/** 设置上料数据 */
export const loadMateriel = (params) => {
  return axios.post(`${rootApi}/loadMateriel`, params)
}

/** 获取批次记录 */
export const batchRecordList = (params) => {
  return axios.get(`/terminal/completeRecord/getCompleteRecordByWorkOrderId`, {params})
}

/** 获取上料记录 */
export const loadMaterialList = (params) => {
  return axios.get(`/terminal/auxiliaryMateriel/getAuxiliaryMaterielByWorkOrder`, {params})
}

/** 获取物料详情 */
export const getMaterialDetail = (params) => {
  return axios.get(`/terminal/technology/materiel/getMaterielDetailedForTerminal`, {params})
}
/** 获取工程注释 */
export const getByProcessFlowOrderIdzs = (params) => {
  return axios.get(`/terminal/technology/craftRoute/getByProcessFlowOrderId/${params}`, )
}

/** 获取工艺路线 */
export const getCraftRoute = (params) => {
  return axios.post(`/terminal/technology/craftRoute/searchListForTerminal`,params,{dataType: 'json'} )
}
/** 获取配料表自定义表头 */
// export const accessotyListHead = () => {
//   return axios.get(`/terminal/productionSetting/getMaterielCustomFieldsShowInTerminal?orderType=MATERIEL`)
// }

/** 获取工序配料表 */
// export const accessotyByProcess = (params) => {
//   return axios.get(`${rootApi}/accessoryByProcess`, {params})
// }
/** 获取相关配料来源设置 */
export const accessorySetting = (itemCode) => {
  return axios.get(`/api_v2/production/setting/accessorySetting/${itemCode}`)
}

/** 获取工序配料表 */
export const accessotyByProcess = (params) => {
  return axios.get(`${rootApi}/accessoryByProcess`, {params})
}

/** 获取BOM配料表 */
export const accessoryByBom = (params) => {
  return axios.get(`${rootApi}/accessoryByBom`, {params})
}
/** 晨龙获取BOM配料表 */
export const accessoryByBomchen = (params) => {
  return axios.get(`/api_v2/production/processFlowOrder/accessoryByBom`, {params})
}
/** 获取物料配料表 */
export const accessoryByMateriel = (params) => {
  return axios.get(`${rootApi}/accessoryByMateriel`, {params})
}

/** 获取制令单配料表 */
export const accessoryByTask = (params) => {
  return axios.get(`${rootApi}/accessoryByTask`, {params})
}

/** 获取SOP文档 */
// export const getWorkOrderDocument = (workOrderId, documentType) => {
//   return axios.get(`${rootApi}/getDocumentByType/${workOrderId}`, {params: {documentType}})
// }
/** 获取所有文档 */
export const getWorkOrderDocument = (params) => {
   return axios.get(`${rootApi}/getDocumentByType`, {params})
}
/** 获取所有PLM文档 */
export const getWorkOrderDocumentPLM = (params) => {
   return axios.get(`${rootApi}/getPlmDocumentByMaterielCode`,{params})
}

/** 获取物料清单 */
export const bomList = (workOrderId) => {
  return axios.get(`${rootApi}/bom/list/${workOrderId}`)
}

/** 获取当前生产中工单 */
export const searchCurrWorkOrder = (params) => {
	return axios.get(`${rootApi}/searchWorkOrder`, {params})
}

/** 创建叫料单 */
export const createCallMaterial = (params) => {
  return axios.post(`${rootApi}/callMaterial/create`, params)
}

/** 获取叫料记录列表 */
export const callMaterialRecordList = (workOrderId) => {
  return axios.get(`${rootApi}/callMaterial/list/${workOrderId}`)
}

/** 获取工序列表 */
export const processList = (workOrderId) => {
  return axios.get(`${rootApi}/processList/${workOrderId}`)
}

/** 获取工单关联工序的参数列表 */
export const processParamList = (workOrderId) => {
  return axios.get(`${rootApi}/processParamList/${workOrderId}`)
}

/** 提交返工 */
export const rewrokSubmit = (params) => {
  return axios.post(`${rootApi}/rework`, params, {dataType: 'json'})
}

// /** 提交报废 */
// export const scrapSubmit = (params) => {
//   return axios.post(`${rootApi}/scrap`, params, {dataType: 'json'})
// }

/** 提交报废 */
export const createScrapSheet = (params) => {
  return axios.post(`/api_v2/production/scrapSheet/createScrapSheet`, params, {dataType: 'json'})
}

/** 提交参数记录 */
export const workOrderParamsSubmit = (params) => {
  return axios.post(`${rootApi}/workOrderParams`, params, {dataType: 'json'})
}

/** 查询报工模式 */
// export const queryReportMode = (workOrderId) => {
//   return axios.get(`${rootApi}/queryReportMode/${workOrderId}`)
// }

/** 阿洛丁管控 */
export const getAlodineControl = (workOrderId) => {
  return axios.get(`${rootApi}/${workOrderId}/alodineControl`)
}
export const postAlodineControl = (workOrderId, params) => {
  return axios.post(`${rootApi}/${workOrderId}/alodineControl`, params, {dataType: 'json'})
}

/** 喷涂管控 */
export const getSprayControl = (workOrderId) => {
  return axios.get(`${rootApi}/${workOrderId}/sprayControl`)
}
export const postSprayControl = (workOrderId, params) => {
  return axios.post(`${rootApi}/${workOrderId}/sprayControl`, params, {dataType: 'json'})
}

/** 机器使用记录 */
export const getMachineUsageRecord = (workOrderId) => {
  return axios.get(`${rootApi}/${workOrderId}/machineUsageRecord`)
}
export const postMachineUsageRecord = (workOrderId, params) => {
  return axios.post(`${rootApi}/${workOrderId}/machineUsageRecord`, params, {dataType: 'json'})
}

/** 模具使用记录 */
export const getMouldUsageRecord = (workOrderId) => {
  return axios.get(`${rootApi}/${workOrderId}/mouldUsageRecord`)
}
export const postMouldUsageRecord = (workOrderId, params) => {
  return axios.post(`${rootApi}/${workOrderId}/mouldUsageRecord`, params, {dataType: 'json'})
}

/** 下料管控 */
export const getBlankingControl = (workOrderId) => {
  return axios.get(`${rootApi}/${workOrderId}/blankingControl`)
}
export const postBlankingControl = (workOrderId, params) => {
  return axios.post(`${rootApi}/${workOrderId}/blankingControl`, params, {dataType: 'json'})
}

/** 获取批文信息 */
export const loadApprovalInformationList=(params)=>{
  return axios.get(`/api_v2/approval/getApprovalList`, {params})
}

/** 获取参与人员 */
export const getUserListById=(params)=>{
  return axios.get(`/api_v2/workGroup/getUserListById`,{params})
}

/** 班组工单报工 */
export const workTimeReport=(params)=>{
  return axios.post(`/api_v2/production/workOrder/workTimeReport`,params)
}
/** 工序记录确认 */
export const saveProcessRecord2=(params)=>{
  return axios.post(`/api_v2/production/workOrder/saveProcessRecord`,params)
}
/** 在途工单 */
export const inRouteFlowOrder=(params)=>{
  return axios.post(`/api_v2/production/workOrder/inRouteFlowOrder`,params,{dataType: 'json'})
}
/** 在途工单获取详情*/
export const inRouteFlowOrderProcessMessage=(params)=>{
  return axios.post(`/api_v2/production/workOrder/inRouteFlowOrderProcessMessage`,params)
}
/** 在途工单在途详情获取详情*/
export const inOrderMessage=(params)=>{
  return axios.post(`/api_v2/production/processInOrder/inOrderMessage`,params)
}
/** 在途工单在途详情提交备注*/
export const inOrderMessageeditRemark=(params)=>{
  return axios.post(`/api_v2/production/processInOrder/editRemark`,params)
}
/** 报检工单*/
export const inspectorUnsignedList=(params)=>{
  return axios.post(`/api_v2/production/workOrder/inspectorUnsignedList`,params,{dataType: 'json'})
}
/** 生产工单列表 */
export const workOrderDelay = (params) => {
  return axios.post(`${rootApi}/workOrderDelay`, params,{dataType: 'json'})
}

/** 获得单批工单信息* */
export const getOddByProcessCode = (params) => {
  return axios.get(`${rootApi}/getByProcessCode`, {params})
}
/** 获得领单页面信息* */
export const getByProcessCodeForReceive = (params) => {
  return axios.get(`${rootApi}/getByProcessCodeForReceive`, {params})
}
/** 获得单批领单选择工序* */
export const receiveSelectProcess = (params) => {
  return axios.get(`${rootApi}/receiveSelectProcess`, {params})
}
/** 单批工单领单*/
export const receiveOddOrder = (params) => {
  return axios.get(`${rootApi}/receiveWorkOrder`, {params})
}
/** 班组工单报工产品序列号*/
export const getSerialNumsByWorkOrder = (params) => {
  return axios.get(`${rootApi}/getSerialNumsByWorkOrder`, {params})
}
/** 班组工单报工产品提交序列号*/
export const updateSerialNum = (params) => {
  return axios.post(`/api_v2/productionPlanOrderApi/updateSerialNum`, params,)
}
/** 根据物料id获取补料单列表 */
export const getChildBomList=(materielId)=>{
  return axios.get(`/api_v2/production/supplementaryMaterialOrder/${materielId}/getChildBomList`)
}
/** 获取仓库列表 */
export const getWarehousestorageData=(params)=>{
  return axios.get(`/api_v2/warehouse/getWarehouseStorageData`,{params})
}
/** 仓库id查询库存物料信息 */
export const getWarehouseGoodsInfoData=(params)=>{
  return axios.get(`/api_v2/warehouse/getWarehouseGoodsInfoData`,{params},)
}
/** 提交物料叫料 */
export const createSupplementaryMaterialOrder=(params)=>{
  return axios.post('/api_v2/production/supplementaryMaterialOrder/createSupplementaryMaterialOrder',params,{dataType:'json'})
}
/** 物料查看图纸 */
export const getBindDocumentList=(params)=>{
  return axios.get('/terminal/technology/materiel/getBindDocumentList',{params},)
}